import type { HelpFile } from '../../types/help'
import { CampaignFormFieldsTestIds } from '../../../testids/CampaignFormFieldsTestIds'

export const campaignFormFieldsHelp: HelpFile = {
  docPage: '/docs/governance/certification-campaigns',
  texts: {
    [CampaignFormFieldsTestIds.campaignInputName]:
      'Name shown for the campaign in lists and reviewer notifications.',
    [CampaignFormFieldsTestIds.campaignInputDescription]:
      'Optional description shown to reviewers when they open the campaign.',
    [CampaignFormFieldsTestIds.campaignInputDueDate]:
      'Due date by which all reviews in the campaign must be completed.',
    [CampaignFormFieldsTestIds.campaignComboboxOwner]:
      'Identity accountable for the campaign — receives reminders and overdue alerts.',
  },
}
